import { render, staticRenderFns } from "./feed-edit.vue?vue&type=template&id=38cd497e&scoped=true&"
import script from "./feed-edit.vue?vue&type=script&lang=js&"
export * from "./feed-edit.vue?vue&type=script&lang=js&"
import style0 from "./feed-edit.vue?vue&type=style&index=0&id=38cd497e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cd497e",
  null
  
)

export default component.exports